const axios = require("axios");

const TestButton = (editor) => {
  editor.BlockManager.add("TestButton", {
    label: "TestButton",
    content: `
     <div>Test Components</div>`,
  });
};

const ImageObj = (editor) => {
  editor.BlockManager.add("ImageText", {
    label: "ImageText",
    content: `<table style="width:100%">
    <tr>
      <th><img  src=""/></th>
      <th>
      <div style="font-weight:normal">

      Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.


</div>
    </th>
    </tr>


  </table>`,
    category: "Basic",
    attributes: {
      title: "Image And Text",
      class: "fa fa-newspaper-o",
    },
  });
};

const ContacComponent = (editor) => {
  editor.BlockManager.add("ContactForum", {
    label: "Contact Forum",
    type: "newtype",
    content: `


<div id="form-id" style="
text-align: center;
font-size:17px;
margin:10px;
font-weight:bold;
color:#454343;
">
<p style="margin:10px;">Yorum ve Görüşlerinizi Bizimle Paylaşın</p>
<div>Adınızı ve  Soyadınızı Yazın</div>
<div>
<input id="AdSoyad"
name="AdSoyad"
style="
border-radius: 25px;
border-radius: 10px;
border: 2px solid #ccc;
padding: 5px;
width: 95%;
height:30px;
margin:10px;
  "
  type="text" value="" placeholder="Adınız Soyadınız"/>
</div>
<div>Mail Adresiniz</div>

<div>
<input
id="MailAdresi"
name='MailAdresi'
style="
border-radius: 10px;
  border: 2px solid #ccc;
  padding: 5px;
  width: 95%;
  height:30px;
  margin:10px;
  "
  type="text" value="" placeholder="Mail Adresinizi Yazın"/>
</div>
<div>Telefon Numarası</div>
<div>
<input
id="TelefonNo"
name='TelefonNo'
style="
border-radius: 10px;
  border: 2px solid #ccc;
  padding: 5px;
  width: 95%;
  height:30px;
  margin:10px;
  "
  type="text" value="" placeholder="Telefon Numarasınızı Yazınız"/>
</div>
<div>Mesajınızı Yazın</div>
<div>
<input
id="Mesaj"
name='Mesaj'
style="
border-radius: 10px;
  border: 2px solid #ccc;
  padding: 5px;
  width: 95%;
  height:70px;
  margin:10px;
  "
  type="text" value="" placeholder="Mesajınızı Yazın"/>
</div>
<div style="text-align: right;height:55px;">
<input id="MailButton"
name='MailButton'
style="
width:100px;
height:35px;
border: 2px solid #ccc;
border-radius: 10px;
margin:10px
"type="button"  value="Gönder"  />
</div>

</div>
<div style="padding:10px;height:35px;">
</div>

<div class="MyTest"></div>


        `,
    category: "Basic",
    attributes: {
      title: "Attributes Test",
      class: "fa fa-commenting-o",
    },
  });
};

const CustomText = (editor) => {
  editor.BlockManager.add("CustomText", {
    label: "Test Component",
    content: '<div data-gjs-type="test-component">Test Component</div>',
  });
};


const ImageWithIcon=(editor)=>{
  
  editor.BlockManager.add("ImageWithIcon",{
    
    type:'ImageWithIcon',
    label:"DownloadImage",
    content:'<img name="downloadImage"  src=""></img>',
    
    
  })
}

const Deneme=(editor)=>{
editor.BlockManager.add("Deneme",{
  type:'denemeType',
  label:'Deneme Label',
  content:`<div data-role="accordion">
  <h3>Section 1</h3>
  <div>
      <p>
          Mauris mauris ante, blandit et, ultrices a, suscipit eget, quam. Integer ut neque. Vivamus nisi metus, molestie vel, gravida in, condimentum sit amet, nunc. Nam a nibh. Donec suscipit eros. Nam mi. Proin viverra leo ut odio. Curabitur malesuada. Vestibulum a velit eu ante scelerisque vulputate.
      </p>
  </div>
  <h3>Section 2</h3>
  <div>
      <p>
          Sed non urna. Donec et ante. Phasellus eu ligula. Vestibulum sit amet purus. Vivamus hendrerit, dolor at aliquet laoreet, mauris turpis porttitor velit, faucibus interdum tellus libero ac justo. Vivamus non quam. In suscipit faucibus urna.
      </p>
  </div>
  <h3>Section 3</h3>
  <div>
      <p>
          Nam enim risus, molestie et, porta ac, aliquam ac, risus. Quisque lobortis. Phasellus pellentesque purus in massa. Aenean in pede. Phasellus ac libero ac tellus pellentesque semper. Sed ac felis. Sed commodo, magna quis lacinia ornare, quam ante aliquam nisi, eu iaculis leo purus venenatis dui.
      </p>
      <ul>
          <li>List item one</li>
          <li>List item two</li>
          <li>List item three</li>
      </ul>
  </div>
  <h3>Section 4</h3>
  <div>
      <p>
          Cras dictum. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Aenean lacinia mauris vel est.
      </p>
      <p>
          Suspendisse eu nisl. Nullam ut libero. Integer dignissim consequat lectus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.
      </p>
  </div>
</div>`
})
}

module.exports = {
  ContacComponent,
  TestButton,
  ImageObj,
  CustomText,
  ImageWithIcon,
  Deneme
};
